// extracted by mini-css-extract-plugin
export default {"sectionDetails":"SectionBanner_sectionDetails__6tjKe","title":"SectionBanner_title__lz6im"};